function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import { renderless, api } from "@opentiny/vue-renderless/dropdown/vue";
import { defineComponent, $prefix, directive, $props, setup as _setup, h } from "@opentiny/vue-common";
import Button from "@opentiny/vue-button";
import ButtonGroup from "@opentiny/vue-button-group";
import Clickoutside from "@opentiny/vue-renderless/common/deps/clickoutside";
import { iconChevronDown, iconChevronUp } from "@opentiny/vue-icon";
function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, shadowMode) {
  var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
  if (render) {
    options.render = render;
    options.staticRenderFns = staticRenderFns;
    options._compiled = true;
  }
  if (functionalTemplate) {
    options.functional = true;
  }
  if (scopeId) {
    options._scopeId = "data-v-" + scopeId;
  }
  var hook;
  if (moduleIdentifier) {
    hook = function hook2(context) {
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
      if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        context = __VUE_SSR_CONTEXT__;
      }
      if (injectStyles) {
        injectStyles.call(this, context);
      }
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    options._ssrRegister = hook;
  } else if (injectStyles) {
    hook = shadowMode ? function() {
      injectStyles.call(this, (options.functional ? this.parent : this).$root.$options.shadowRoot);
    } : injectStyles;
  }
  if (hook) {
    if (options.functional) {
      options._injectStyles = hook;
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return {
    exports: scriptExports,
    options
  };
}

var __vue2_script = defineComponent({
  name: $prefix + "Dropdown",
  componentName: "TinyDropdown",
  components: {
    TinyButton: Button,
    TinyButtonGroup: ButtonGroup,
    IconChevronDown: iconChevronDown(),
    IconChevronUp: iconChevronUp()
  },
  directives: directive({
    Clickoutside
  }),
  props: _extends({}, $props, {
    type: String,
    trigger: {
      type: String,
      default: "click"
    },
    size: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    singleButton: {
      type: Boolean,
      default: false
    },
    splitButton: Boolean,
    showTimeout: {
      type: Number,
      default: 250
    },
    hideTimeout: {
      type: Number,
      default: 150
    },
    hideOnClick: {
      type: Boolean,
      default: true
    },
    tabindex: {
      type: Number,
      default: 0
    },
    border: {
      type: Boolean,
      default: false
    },
    round: {
      type: Boolean,
      default: false
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    modelValue: [String, Number],
    showSelfIcon: {
      type: Boolean,
      default: false
    }
  }),
  emits: ["visible-change", "item-click", "button-click", "selectedIndex", "current-item-click"],
  setup: function setup(props, context) {
    return _setup({
      props,
      context,
      renderless,
      api,
      h
    });
  },
  render: function render() {
    var h2 = arguments[0];
    var type = this.type, disabled = this.disabled, handleMainButtonClick = this.handleMainButtonClick, slots = this.slots, size = this.size, state = this.state, border = this.border, round = this.round, m = this.m, clickOutside = this.clickOutside, singleButton = this.singleButton;
    var params = {
      visible: state.visible
    };
    var triggerElm = null;
    if (singleButton) {
      triggerElm = h2("tiny-button", {
        "ref": "trigger",
        "attrs": {
          "type": type === "primary" ? type : "",
          "size": size,
          "buttonClass": m(["rounded-sm active:rounded flex items-center justify-center", state.visible && type !== "primary" && "active:border-color-border-focus text-color-text-primary active:text-color-brand-focus focus:border-color-border-focus focus:text-color-brand-focus"]),
          "disabled": disabled,
          "reset-time": 0
        },
        "nativeOn": {
          "click": handleMainButtonClick
        }
      }, [h2("div", {
        "class": "overflow-hidden overflow-ellipsis whitespace-nowrap w-full"
      }, [slots.default && slots.default(params)])]);
    } else {
      var defaultSlot = slots.default && slots.default(params);
      var suffixSlot = slots["suffix-icon"] && slots["suffix-icon"]();
      var vnodeData = (defaultSlot == null ? void 0 : defaultSlot[0].data) || {};
      var _vnodeData$attrs = vnodeData.attrs, attrs = _vnodeData$attrs === void 0 ? {} : _vnodeData$attrs;
      if (disabled && !attrs.disabled) {
        attrs.disabled = true;
        vnodeData.attrs = attrs;
      }
      var suffixInner = state.showIcon && h2("span", {
        "class": ["ml-1 sm:ml-2 [&>svg:nth-of-type(1)]:align-top w-4 h-4 inline-block [&_svg]:transition-transform [&_svg]:duration-300", {
          "fill-color-brand-focus [&>svg:nth-of-type(1)]:hover:fill-color-brand-hover [&>svg:nth-of-type(1)]:active:fill-color-brand-focus leading-4": !disabled && !border
        }, border && (state.visible ? "[&_svg]:rotate-180" : "[&_svg]:rotate-0"), border && type !== "primary" && state.visible && "[&_svg]:fill-color-border-focus visited:[&_svg]:fill-color-border-focus active:[&_svg]:fill-color-border-focus"]
      }, [suffixSlot || h2("icon-chevron-down")]);
      triggerElm = border ? h2("tiny-button", {
        "ref": "trigger",
        "attrs": {
          "round": round,
          "size": size,
          "type": type === "primary" ? type : "",
          "disabled": disabled,
          "reset-time": 0
        },
        "class": ["rounded-sm inline-flex items-center justify-center", type === "primary" ? "[&_svg]:fill-color-bg-1" : state.visible ? "active:border-color-border-focus text-color-text-primary active:text-color-brand-focus focus:border-color-border-focus focus:text-color-brand-focus" : "[&_svg]:fill-color-icon-placeholder"]
      }, [defaultSlot, suffixInner]) : h2("span", {
        "ref": "trigger",
        "class": [state.visible ? "[&_svg]:rotate-180" : "[&_svg]:rotate-0", disabled && "cursor-not-allowed [&_svg]:fill-color-text-disabled", "inline-flex [&_svg]:transition-transform [&_svg]:duration-300"]
      }, [h2("span", {
        "class": ["inline-flex h-4 leading-4", disabled ? "text-color-text-disabled" : "hover:text-color-brand-hover active:text-color-brand-focus"]
      }, [defaultSlot]), h2("span", {
        "class": "align-bottom leading-4"
      }, [suffixInner])]);
    }
    var menuElm = disabled ? null : slots.dropdown && slots.dropdown();
    return h2("div", {
      "class": ["relative inline-block [&>span:nth-of-type(1)]:text-color-brand-focus [&>span:nth-of-type(1)]:text-sm sm:[&>span:nth-of-type(1)]:text-xs", disabled && "[&>span:nth-of-type(1)]:text-color-brand-focus", state.showSelfIcon && "leading-4 h-4 [&_svg]:align-top [&_svg]:rotate-0"],
      "directives": [{
        name: "clickoutside",
        value: clickOutside
      }],
      "attrs": {
        "aria-disabled": disabled
      }
    }, [triggerElm, menuElm]);
  }
});
var __vue2_render, __vue2_staticRenderFns;
var __cssModules = {};
var __component__ = /* @__PURE__ */ normalizeComponent(__vue2_script, __vue2_render, __vue2_staticRenderFns, false, __vue2_injectStyles, null, null, null);
function __vue2_injectStyles(context) {
  for (var o in __cssModules) {
    this[o] = __cssModules[o];
  }
}
var mobileFirst = /* @__PURE__ */ function() {
  return __component__.exports;
}();
export {
  mobileFirst as default
};
